<template>
  <div class="scanning-modal">
    <Modal
      v-model="showModal"
      :title="typeModal == 'edit' ? `上传结算扫描件` : `图片查看`"
      :width="typeModal == 'edit' ? 800 : 1000"
      :closable="false"
      :mask-closable="false"
      @on-ok="handleOk"
      @on-cancel="handleCancel"
    >
      <div v-if="typeModal == 'edit'" class="scanning-modal-main">
        <div class="item">
          <p>机构上传扫描件：</p>
          <ul>
            <li v-for="(item, index) in settleAttachmentExs" :key="index">
              <img class="img" :src="item.localUrl">
              <Icon
                v-if="[0, 2, 3].includes(Number(portOrg))"
                class="close"
                type="md-close-circle"
                size="20"
                color="red"
                @click="handleDelete('settleAttachmentExs', index)"
              ></Icon>
            </li>
            <li
              v-if="
                settleAttachmentExs.length < 9 &&
                  [0, 2, 3].includes(Number(portOrg))
              "
            >
              <UploadBtn
                :text="'上传图片（最大支持9张）'"
                class="upload"
                :upload-type="uploadType"
                :accept="`image/*`"
                @on-success="handleEXImg"
              ></UploadBtn>
            </li>
          </ul>
        </div>
        <div class="item">
          <p>平台上传扫描件：</p>
          <ul>
            <li v-for="(item, index) in settleAttachments" :key="index">
              <img class="img" :src="item.localUrl">
              <Icon
                v-if="portOrg == 0"
                class="close"
                type="md-close-circle"
                size="20"
                color="red"
                @click="handleDelete('settleAttachments', index)"
              ></Icon>
            </li>
            <li v-if="settleAttachments.length < 9 && portOrg == 0">
              <UploadBtn
                :text="'上传图片（最大支持9张）'"
                class="upload"
                :accept="`image/*`"
                :upload-type="uploadType"
                @on-success="handleCoverImg"
              ></UploadBtn>
            </li>
          </ul>
        </div>
      </div>
      <div v-else class="scanning-modal-main">
        <Tabs :value="tab" @on-click="onClickTab">
          <TabPane label="机构上传扫描件" name="1">
            <div v-if="settleAttachmentExs.length" class="image-cover">
              <Carousel
                v-if="showCarousel"
                v-model="swiperExIndex"
                dots="none"
                :arrow="arrowEx"
              >
                <CarouselItem
                  v-for="(item, index) in settleAttachmentExs"
                  :key="index"
                >
                  <div class="demo-carousel">
                    <el-image
                      style="width: 700; height: 500px"
                      :src="item.localUrl"
                      :preview-src-list="settleAttachmentExsUrl"
                    >
                    </el-image>
                    <!-- <img :src="item.localUrl" alt="" /> -->
                  </div>
                </CarouselItem>
              </Carousel>
            </div>
          </TabPane>
          <TabPane label="平台上传扫描件" name="2">
            <div v-if="settleAttachments.length" class="image-cover">
              <Carousel
                v-if="showCarousel"
                v-model="swiperIndex"
                dots="none"
                :arrow="arrow"
              >
                <CarouselItem
                  v-for="(item, index) in settleAttachments"
                  :key="index"
                >
                  <div class="demo-carousel">
                    <el-image
                      style="width: 700px; height: 500px"
                      :src="item.localUrl"
                      :preview-src-list="settleAttachmentsUrl"
                    >
                    </el-image>
                    <!-- <img :src="item.localUrl" alt="" /> -->
                  </div>
                </CarouselItem>
              </Carousel>
            </div>
          </TabPane>
        </Tabs>
      </div>
      <div slot="footer">
        <Button @click="handleCancel">取消</Button>
        <Button
          v-if="typeModal == 'edit'"
          type="primary"
          @click="handleOk"
        >确定</Button>
      </div>
    </Modal>
  </div>
</template>

<script>
import UploadBtn from './UploadBtn';
import { readFileOfImage, add } from '@/utils/utils';
import { compressPic } from '@/utils/imageHelper';
import axios from 'axios';
import orderCenterApi from '@/request/orderCenter/index.js';
export default {
  components: {
    UploadBtn
  },
  props: {
    sheetId: {
      type: [String, Number],
      default: ''
    },
    statementId: {
      type: [String, Number],
      default: ''
    },
    show: {
      type: Boolean,
      default: false
    },
    settleAttachmentEx: {
      type: [String, Object],
      default: ''
    },
    settleAttachment: {
      type: [String, Object],
      default: ''
    },
    typeModal: {
      type: String,
      default: 'edit'
    },
    orgId: {
      type: String,
      default: ''
    },
    settleMonth: {
      type: String,
      default: ''
    },
    billPlatfromMode: {
      type: String,
      default: '1'
    }
  },

  data() {
    return {
      swiperIndex: 0,
      swiperExIndex: 0,
      tab: '1', // 1: 机构上传扫描件 2:平台上传扫描件
      showModal: false,
      uploadType: 1,
      source: null, // 上传的
      uploadToken: '',
      UploadUrl: '',
      downloadUrl: '',
      uploadPersent: 0, // 上传进度
      settleAttachments: [], // 运营端
      settleAttachmentsUrl: [],
      settleAttachmentExs: [], // 机构端
      settleAttachmentExsUrl: [],
      portOrg: localStorage.getItem('portOrg'),
      showCarousel: false // 走马灯初始化时不显示的解决方法
    };
  },
  computed: {
    arrow() {
      if (this.settleAttachments.length === 1) {
        return 'never';
      } else {
        return 'always';
      }
    },
    arrowEx() {
      if (this.settleAttachmentExs.length === 1) {
        return 'never';
      } else {
        return 'always';
      }
    }

  },
  watch: {
    show(val) {
      this.swiperIndex = 0;
      this.swiperExIndex = 0;
      this.showModal = val;
      this.initImage();
      this.$nextTick(() => {
        this.showCarousel = true;
      });
    }
  },
  created() {
    this.getUploadtoken();
  },
  methods: {
    onClickTab(name) {
      this.tab = name;
    },
    async initImage() {
      this.settleAttachments = [];
      this.settleAttachmentsUrl = [];
      this.settleAttachmentExs = [];
      this.settleAttachmentExsUrl = [];
      // 有附件 且打开showmodal

      if (this.settleAttachment) {
        this.settleAttachment.split(';').forEach((fileId) => {
          this.settleAttachmentsUrl.push(this.downloadUrl + '?fileId=' + fileId);
          this.settleAttachments.push({
            type: 1,
            localUrl: this.downloadUrl + '?fileId=' + fileId,
            fileId: fileId
          });
        });
      }
      if (this.settleAttachmentEx) {
        this.settleAttachmentEx.split(';').forEach((fileId) => {
          this.settleAttachmentExsUrl.push(this.downloadUrl + '?fileId=' + fileId);
          this.settleAttachmentExs.push({
            type: 1,
            localUrl: this.downloadUrl + '?fileId=' + fileId,
            fileId: fileId
          });
        });
      }
    },
    handleCoverImg(files) {
      const kb = files[0].size / 1024;
      if (kb > 1 * 1024 * 1024) {
        this.$Message.warning('单张图片最大支持上传10M');
        return null;
      }
      this.getBase64Img(files, 'settleAttachments');
    },
    handleEXImg(files) {
      const kb = files[0].size / 1024;
      if (kb > 1 * 1024 * 1024) {
        this.$Message.warning('单张图片最大支持上传10M');
        return null;
      }
      this.getBase64Img(files, 'settleAttachmentExs');
    },
    handleDelete(Target, index) {
      this[Target].splice(index, 1);
    },
    // 上传token
    async getUploadtoken() {
      return new Promise((resolve, reject) => {
        this.$http.getUploadtoken().then((res) => {
          this.uploadToken = res.message.token;
          this.UploadUrl = res.message.upUrl;
          this.downloadUrl = res.message.downUrl;
          resolve(res);
        });
      });
    },
    async getBase64Img(files, Target) {
      const file = files[0];
      const fileSize = file.size;
      try {
        // this.imgSrc = '';
        const result = await readFileOfImage(file);
        let yaImageStr = ''; // 压缩后的base64图片
        // 如果图片大小大于200k,先进行压缩
        if (Math.round(fileSize / 1024) > 200) {
          yaImageStr = await compressPic(result, {
            quality: 0.7
          });
        } else {
          yaImageStr = result;
        }
        // const obj = {
        //   localUrl: yaImageStr,
        //   file: file
        // };
        this[Target].push({
          localUrl: yaImageStr,
          file: file,
          type: 2// 1: 后端返回，2:源文件
        });

        // const id = await this.uploadImg(obj.file);
        //  this[list].push(id);
      } catch (error) {
        this.$Message.warning('读取图片失败');
      }
    },
    async Bulkupload() {
      const attsIds = []; const attsExIds = []; const attsPromises = [];
      for (let i = 0, len = this.settleAttachments.length; i < len; i++) {
        const file = this.settleAttachments[i];
        if (file.type == 1) {
          attsIds.push(file.fileId);
        } else {
          const id = await this.uploadImg(file.file);
          attsIds.push(id);
        }
      }
      for (let i = 0, len = this.settleAttachmentExs.length; i < len; i++) {
        const file = this.settleAttachmentExs[i];
        if (file.type == 1) {
          attsExIds.push(file.fileId);
        } else {
          const id = await this.uploadImg(file.file);
          attsExIds.push(id);
        }
      }
      this.handleSubmit(attsIds, attsExIds);
    },
    async handleSubmit(attsIds, attsExIds) {
      let res;
      const parameter = {
        settleAttachment: attsIds.join(';'),
        settleAttachmentEx: attsExIds.join(';')
      };
      if (this.billPlatfromMode === '3') {
        parameter.orgId = this.orgId;
        parameter.settleMonth = this.settleMonth;
        parameter.objId = add(this.orgId, this.settleMonth.replace('-', ''));
        res = await orderCenterApi.uploadBillReviewFormApi(parameter);
      } else {
        parameter.sheetId = this.sheetId;
        res = await orderCenterApi.uploadBillReviewForm(parameter);
      }
      // if (this.portOrg == 0 || this.portOrg == 2) {
      // }
      // if (this.portOrg == 3) {
      //   res = await orderCenterApi.uploadStatementSheetImgByOrg(parameter)
      // }

      if (res.data.status == 200) {
        this.$emit('on-finish');
        console.log('成功');
      }
      this.$Spin.hide();
    },
    // 上传图片
    async uploadImg(ev) {
      return new Promise(async(resolve, reject) => {
        const file = ev;
        const formData = new FormData();
        formData.append('token', this.uploadToken);
        formData.append('file', file);
        const token = localStorage.getItem('loginToken');
        this.source = axios.CancelToken.source();
        var configs = {
          // 上传文件 请求头要设置成下面这样
          headers: {
            token: token,
            'Content-Type': 'application/x-www-form-urlencoded'
          },
          onUploadProgress: progressEvent => {
            if (progressEvent.lengthComputable) {
              const val = (progressEvent.loaded / progressEvent.total * 100).toFixed(0);
              this.uploadPersent = parseInt(val);
            }
          },
          cancelToken: this.source.token
        };

        axios.post(this.UploadUrl, formData, configs).then(res => {
          if (res.data.status === 200) {
            const id = res.data.message.fileId;

            resolve(id);
          } else {
            this.$Spin.hide();
            reject(res.data.error);
            this.$Message.warning(res.data.error);
          }
        }).catch(err => {
          if (err.message) {
            this.$Message.error(err.message);
          }
        }).finally(() => {

        });
      });
    },
    async handleOk() {
      if (this.typeModal === 'edit') {
        // if (this.portOrg == 0) {
        //   if (!this.settleAttachmentExs.length && !this.settleAttachments.length) {
        //     return this.$Message.warning('请上传图片')
        //   }
        // } else {
        //   if (!this.settleAttachmentExs.length) {
        //     return this.$Message.warning('请上传图片')
        //   }
        // }
        this.$Spin.show();
        await this.getUploadtoken();
        this.Bulkupload();
      } else {

      }
    },
    handleCancel() {
      this.$emit('on-cancel');
    }
  }
};
</script>
<style lang="scss" >
.scanning-modal-main {
  .item {
    ul {
      display: flex;
      padding: 16px 0;
      li {
        margin-right: 16px;
        position: relative;
        .img {
          width: 64px;
          height: 64px;
          border: 1px solid #eee;
          border-radius: 4px;
        }
        .close {
          position: absolute;
          right: 0;
          top: 0;
          cursor: pointer;
        }
      }
    }
  }
  .image-cover {
    width: 700px;
    height: 500px;
    margin: 0 auto;
    // /deep/.ivu-carousel{
    //   height: 100%;
    // }
    // /deep/.ivu-carousel-list{
    //   height: 100%;
    // }
    // /deep/.ivu-carousel-item{
    //   height: 350px;
    // }
    .demo-carousel {
      width: 700px;
      height: 500px;
      img {
        width: 100%;
        height: 100%;
        object-fit: contain;
      }
    }
  }
}
</style>
